export default "__VITE_ASSET__ede702dc__"